module.exports = __webpack_public_path__ + "static/media/app.a930472b.png";